<template>
  <section>
    <div class="header">
      <p>{{title}}</p>
    </div>

    <div class="body">
      <el-form
        ref="form"
        :model="formData"
        :rules="extraRules">
        <el-form-item
          ref="code"
          class='form-item'
          prop="code">
          <span class="item-title">Trial Code</span>
          <v-input
            v-model="formData.code"
            :disabled="!isCreate"
            uppercase
            class="input"></v-input>
        </el-form-item>
        <div class="line"></div>
        <el-form-item class='form-item'>
          <span class="item-title">Length</span>
          <v-radio-group
            v-model="formData.day_type"
            :disabled="!isCreate"
            :list="lengthOptions"></v-radio-group>
        </el-form-item>
        <template v-if="false">
          <div class="line"></div>
          <div class='form-item flex-column'>
            <span class="title">Related Team Head</span>
            <span v-if="formData.team_head_user_id ">
              <span class="user-content">
                <span class="user-content__phone">{{user.registered_login}}</span>
                <span class="user-content__name">{{ user.isrd_nm != ' '? user.isrd_nm : 'Unnamed Account'}}</span>
                <span
                  class="user-content__phone blue pointer"
                  @click="handleCancelSelect">Detach</span>
              </span>
            </span>
            <span v-else>
              <v-button
                gray
                icon="plus"
                @click="handleSelect">Add</v-button>
            </span>
          </div>
        </template>
        <div class="line"></div>

        <el-form-item class='form-item'>
          <span class="title">Restrictions</span>
          <v-checkbox
            v-model="formData.user_use_times"
            :disabled="!isCreate"
            :isBoolean="false">Once Per Customer</v-checkbox>
        </el-form-item>

        <div class="line"></div>

        <el-form-item class='form-item'>
          <span class="title">Activity</span>
          <el-form-item class="form-item time">
            <span class="item-title">Time Period</span>
            <v-date-picker
              v-model="formData.date"
              class="input"
              type="daterange"/>

          </el-form-item>
          <v-checkbox
            v-model="formData.status"
            :isBoolean="false">Activated</v-checkbox>
        </el-form-item>

        <div class="line"></div>
      </el-form>
    </div>

    <div class="btn">
      <v-button
        class="cancel"
        @click="handleCancel">Cancel</v-button>
      <v-button
        class="success"
        @click="handleSave">Save</v-button>
    </div>
    <attach-customer
      ref="attachCustomer"
      is-share
      is-all-type
      @shareUser="handleSelectUser"></attach-customer>
  </section>
</template>

<script>
import {createTrailCode, EditTrailCode} from '@/api/trailCode'
import MixinOptions from '@/mixins/options'
import {mapState} from 'vuex'
import attachCustomer from '@/views/quoting/dialogs/attachCustomer'
export default {
  name: 'TrailCodeDetail',
  components:{
    attachCustomer
  },
  mixins: [MixinOptions],
  data () {
    return {
      formData:{
        code: '',
        day_type: 1,
        user_use_times: 1,
        status: '',
        date: '',
        start_time: '',
        end_time: '',
        // team_head_user_id: '',
      },
      user:{},
      extraRules:{
        code:[
          { required: true, message: this.$t('placeholder.input'), trigger: ['blur','change'] }
        ],
      }
    }
  },
  computed:{
    ...mapState('trialCode', ['status', 'codeData']),
    isCreate(){
      return this.status == 'create'? true : false
    },
    title(){
      return this.isCreate? 'Create Trial Code' : 'Trial Code'
    }
  },
  watch:{
    codeData:{
      immediate: true,
      deep: true,
      handler(val){
        if(val && Object.keys(val).length){
          Object.keys(val).forEach(key => {
            if(key == 'status'){
              this.formData[key] = val[key] == 1? 1 : 0
            }else{
              this.formData[key] = val[key]
            }
          })
        }
      }
    },
    'formData.start_time':{
      immediate: true,
      handler(val){
        if(val && this.formData.end_time){
          let arr = []
          arr.push(val)
          arr.push(this.formData.end_time)
          this.formData.date = JSON.parse(JSON.stringify(arr))
        }
      }
    }
  },
  methods: {
    handleSelect(){
      this.$refs.attachCustomer.showAttachCustomer()
    },
    handleCancelSelect(){
      this.formData.team_head_user_id = ''
    },
    handleSelectUser(userId,userData){
      this.formData.team_head_user_id = userId
      this.user = userData
    },
    handleCancel(){
      this.$router.back()
    },
    handleSave(){
      this.$refs['form'].validate((valid, rules) => {
        if(valid){
          this.network().createTrailCode()
        }else{
          this.scrollToValidDom(rules)
        }
      })
    },
    network(){
      return {
        createTrailCode: async () => {
          let form = this.formData
          if(this.isCreate){
            var {data} = await createTrailCode({
              code: form.code,
              day_type: form.day_type,
              user_use_times: form.user_use_times,
              status: form.status==1? 1 : 2,
              start_time: form.date[0],
              end_time: form.date[1],
              // team_head_user_id: form.team_head_user_id,
            })
          }else{
            var {data} = await EditTrailCode({
              code: form.code,
              day_type: form.day_type,
              user_use_times: form.user_use_times,
              status: form.status==1? 1 : 2,
              start_time: form.date[0],
              end_time: form.date[1],
              // team_head_user_id: form.team_head_user_id,
            })
          }
          if(data.code == 1000){
            this.$message({
              message: 'Success',
              type: 'success'
            })
            this.$router.push({
              path: '/admin-cms/trial-codes'
            })
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.header{
  p{
    font-weight: 600;
    font-size: 24px;
  }
}
.body{
  margin-top: 30px;
  .input{
    width: 330px;
  }
  .line{
    border: 1px solid #D1D5DA;
    margin: 30px 0;
  }
  .form-item{
    padding-bottom: 0;
    span.title{
      font-size: 16px;
      padding-bottom: 20px;
      font-weight: 600;
      color: #24292E;
    }
    span.item-title{
      padding-bottom: 8px;
      font-weight: 600;
      font-size: 14px;
      color: #24292E;
      display: block;
    }
    .time{
      padding-bottom: 20px;
    }
  }
}
.btn{
  display: flex;
  justify-content: space-between;
  .el-button{
    border-radius: 6px;
  }
  .cancel{
    background: #FAFBFC;
    border: 1px solid rgba(27, 31, 35, 0.15);
    box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
  }
  .success{
    background: #2EA44F;
    border: 1px solid rgba(27, 31, 35, 0.15);
    box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
    color: #FFFFFF;
  }
}
.user-content{
  .user-content__phone{
    color: $dark;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    display: block;
    margin-bottom: 4px;
    &.blue{
      color: $blue;
    }
  }
  .user-content__name{
         color:#6A737D;
         font-size: 12px;
         font-style: normal;
    display: block;
         font-weight: 400;
         line-height: 18px;
  }
}
/deep/ .el-radio-group {
  display: flex;
  flex-direction: column;
  .el-radio + .el-radio{
    margin-top: 20px;
    display: flex;
  }
}
.el-checkbox{
  font-weight: 600;
  font-size: 14px;
  color: #24292E;
}
</style>
